'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');
var Table$1 = require('../../../node_modules/@material-ui/core/esm/Table/Table.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"]({
  allBorders: {
    border: '1px solid #e0e0e0'
  },
  noBorders: {
    border: 'hidden'
  },
  outerVerticalBorders: {
    borderStyle: 'solid',
    borderLeftWidth: '1px',
    borderTopStyle: 'hidden',
    borderBottomStyle: 'hidden',
    borderRightWidth: '1px',
    borderColor: '#e0e0e0'
  },
  outerHorizontalBorders: {
    borderStyle: 'solid',
    borderLeftStyle: 'hidden',
    borderTopWidth: '1px',
    borderBottom: '1px',
    borderRightStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  outerTopBorder: {
    borderStyle: 'solid',
    borderLeftStyle: 'hidden',
    borderTopWidth: '1px',
    borderBottomStyle: 'hidden',
    borderRightStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  outerBottomBorder: {
    borderStyle: 'solid',
    borderLeftStyle: 'hidden',
    borderTopStyle: 'hidden',
    borderBottomWidth: '1px',
    borderRightStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  outerRightBorder: {
    borderStyle: 'solid',
    borderLeftStyle: 'hidden',
    borderTopStyle: 'hidden',
    borderBottomStyle: 'hidden',
    borderRightWidth: '1px',
    borderColor: '#e0e0e0'
  },
  outerLeftBorder: {
    borderStyle: 'solid',
    borderLeftWidth: '1px',
    borderTopStyle: 'hidden',
    borderBottomStyle: 'hidden',
    borderRightStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  separateBorders: {
    borderCollapse: 'separate'
  }
});

var Table = function Table(_ref) {
  var borders = _ref.borders,
      stickyColumn = _ref.stickyColumn,
      className = _ref.className,
      padding = _ref.padding,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["borders", "stickyColumn", "className", "padding", "children"]);

  var styles = useStyles();
  var appliedBorders = null;

  switch (borders) {
    case 'all':
      appliedBorders = styles.allBorders;
      break;

    case 'interior':
      appliedBorders = styles.noBorders;
      break;

    case 'exterior':
      appliedBorders = styles.allBorders;
      break;

    case 'none':
      appliedBorders = styles.noBorders;
      break;

    case 'noOuterVertical':
      appliedBorders = styles.outerHorizontalBorders;
      break;

    case 'noOuterHorizontal':
      appliedBorders = styles.outerVerticalBorders;
      break;

    case 'onlyVertical':
      appliedBorders = styles.outerVerticalBorders;
      break;

    case 'onlyHorizontal':
      appliedBorders = styles.outerHorizontalBorders;
      break;

    case 'onlyInteriorVertical':
      appliedBorders = styles.noBorders;
      break;

    case 'onlyInteriorHorizontal':
      appliedBorders = styles.noBorders;
      break;

    case 'onlyOuterRight':
      appliedBorders = styles.outerRightBorder;
      break;

    case 'onlyOuterLeft':
      appliedBorders = styles.outerLeftBorder;
      break;

    case 'onlyOuterTop':
      appliedBorders = styles.outerTopBorder;
      break;

    case 'onlyOuterBottom':
      appliedBorders = styles.outerBottomBorder;
      break;
  }

  return React__default["default"].createElement(Table$1["default"], _objectSpread({
    padding: padding,
    size: padding === " dense" ? "small" : undefined,
    className: classNames__default["default"](defineProperty({}, appliedBorders, !!borders), defineProperty({}, styles.separateBorders, !!stickyColumn), className)
  }, props), borders || stickyColumn ? React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      borders: borders,
      stickyColumn: stickyColumn
    });
  }) : children);
};

module.exports = Table;
